/**
 * Уровни серьёзности событий
 * Используется для ошибок и breadcrumbs
 */
enum ErrorLevel {
    Debug = 'debug',
    Info = 'info',
    Warning = 'warning',
    Error = 'error',
    Fatal = 'fatal'
}

export default ErrorLevel;
